/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Shot_Source_Use_MarkersInputs */

const en_ad_shot_source_use_markers = /** @type {(inputs: Ad_Shot_Source_Use_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use My Markers`)
};

const fr_ad_shot_source_use_markers = /** @type {(inputs: Ad_Shot_Source_Use_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez mes marqueurs`)
};

const de_ad_shot_source_use_markers = /** @type {(inputs: Ad_Shot_Source_Use_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutze meine Marker`)
};

const it_ad_shot_source_use_markers = /** @type {(inputs: Ad_Shot_Source_Use_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa i miei marcatori`)
};

const ru_ad_shot_source_use_markers = /** @type {(inputs: Ad_Shot_Source_Use_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте мои маркеры`)
};

const es_ad_shot_source_use_markers = /** @type {(inputs: Ad_Shot_Source_Use_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa mis marcadores`)
};

const zh_cn2_ad_shot_source_use_markers = /** @type {(inputs: Ad_Shot_Source_Use_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用我的标记`)
};

const ja_ad_shot_source_use_markers = /** @type {(inputs: Ad_Shot_Source_Use_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私のマーカーを使ってください`)
};

const hi_ad_shot_source_use_markers = /** @type {(inputs: Ad_Shot_Source_Use_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेरे मार्करों का उपयोग करें`)
};

const pt_pt2_ad_shot_source_use_markers = /** @type {(inputs: Ad_Shot_Source_Use_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use meus marcadores`)
};

/**
* | output |
* | --- |
* | "Use My Markers" |
*
* @param {Ad_Shot_Source_Use_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_shot_source_use_markers = /** @type {((inputs?: Ad_Shot_Source_Use_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Shot_Source_Use_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_shot_source_use_markers(inputs)
	if (locale === "de") return de_ad_shot_source_use_markers(inputs)
	if (locale === "it") return it_ad_shot_source_use_markers(inputs)
	if (locale === "ru") return ru_ad_shot_source_use_markers(inputs)
	if (locale === "es") return es_ad_shot_source_use_markers(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_shot_source_use_markers(inputs)
	if (locale === "ja") return ja_ad_shot_source_use_markers(inputs)
	if (locale === "hi") return hi_ad_shot_source_use_markers(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_shot_source_use_markers(inputs)
	return en_ad_shot_source_use_markers(inputs)
});